"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Why3Icon = void 0;
const React = __importStar(require("react"));
const icons_1 = __importDefault(require("@ant-design/icons"));
const IconSVG = () => React.createElement("svg", { version: "1.0", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 512.000000 512.000000", preserveAspectRatio: "xMidYMid meet" },
    React.createElement("g", { transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)", fill: "currentColor", stroke: "none" },
        React.createElement("path", { d: "M0 4870 l0 -250 1175 0 1175 0 0 250 0 250 -1175 0 -1175 0 0 -250z" }),
        React.createElement("path", { d: "M2770 3945 l0 -1175 250 0 250 0 0 1175 0 1175 -250 0 -250 0 0\n-1175z" }),
        React.createElement("path", { d: "M3690 3945 l0 -1175 255 0 255 0 0 1175 0 1175 -255 0 -255 0 0\n-1175z" }),
        React.createElement("path", { d: "M4620 3945 l0 -1175 250 0 250 0 0 1175 0 1175 -250 0 -250 0 0\n-1175z" }),
        React.createElement("path", { d: "M0 3945 l0 -255 1175 0 1175 0 0 255 0 255 -1175 0 -1175 0 0 -255z" }),
        React.createElement("path", { d: "M0 3020 l0 -250 1175 0 1175 0 0 250 0 250 -1175 0 -1175 0 0 -250z" }),
        React.createElement("path", { d: "M0 1175 l0 -1175 250 0 250 0 0 1175 0 1175 -250 0 -250 0 0 -1175z" }),
        React.createElement("path", { d: "M920 1175 l0 -1175 255 0 255 0 0 1175 0 1175 -255 0 -255 0 0 -1175z" }),
        React.createElement("path", { d: "M1850 1175 l0 -1175 250 0 250 0 0 1175 0 1175 -250 0 -250 0 0\n-1175z" }),
        React.createElement("path", { d: "M2770 2100 l0 -250 1175 0 1175 0 0 250 0 250 -1175 0 -1175 0 0\n-250z" }),
        React.createElement("path", { d: "M2770 1175 l0 -255 1175 0 1175 0 0 255 0 255 -1175 0 -1175 0 0\n-255z" }),
        React.createElement("path", { d: "M2770 250 l0 -250 1175 0 1175 0 0 250 0 250 -1175 0 -1175 0 0 -250z" })));
const Why3Icon = (props) => {
    return React.createElement(icons_1.default, { component: IconSVG, ...props });
};
exports.Why3Icon = Why3Icon;
